<template>
    <ul class="pagination">
        <li v-show="prevUrl" class="page-item">
            <a href="#" aria-label="Previous" rel="prev" @click.prevent="page--">
                <span class="page-link" aria-hidden="true">&laquo; Previous</span>
            </a>
        </li>

        <li v-show="nextUrl" class="page-item">
            <a href="#" aria-label="Next" rel="next" @click.prevent="page++">
                <span aria-hidden="true" class="page-link">Next &raquo;</span>
            </a>
        </li>
    </ul>
</template>

<script>
    export default {
        props: ['dataSet'],

        data() {
            return {
                page: 50,
                prevUrl: false,
                nextUrl: false
            }
        },

        watch: {
            dataSet() {
                this.page = this.dataSet.current_page;
                this.prevUrl = this.dataSet.prev_page_url;
                this.nextUrl = this.dataSet.next_page_url;
            },
            page() {
                if (this.dataSet.current_page === this.page) {
                    return;
                }
                this.broadcast().updateUrl();
            }
        },
        computed: {
            shouldPaginate() {
                return !!this.prevUrl || !!this.nextUrl;
            }
        },
        methods: {
            broadcast() {
                return this.$emit('page_changed', this.page);
            },

            updateUrl() {
                //console.log(this.page);
                //history.pushState(null, null, '?page=' + this.page);
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/Paginator.vue